import { api } from "assets/scripts/utilities/api-clients";

export const get = async (id) => {
  const response = await api.get(`/kam/paymentrequests/${id}`);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("/kam/paymentrequests", options);

  return response;
};

export const indexAccounts = async (options = {}) => {
  const response = await api.get("/kam/account/paymentrequests", options);

  return response;
};

export const reject = async (pr) => {
  const response = await api.put("/kam/paymentrequests/reject", pr);

  return response;
};

export const getPastPRs = async (options = {}) => {
  const response = await api.get(`/kam/paymentrequests/past`, options);

  return response;
};

export const vendorAdvanceAgainstPBAllowed = async () => {
  const response = await api.get(
    "/kam/payment-requests/vendor-advance-against-pb-check",
  );

  return response;
};

export const getPaymentsMade = async (purchaseBillId) => {
  const response = await api.get(`/account/paymentsmade/${purchaseBillId}`);

  return response;
};

export const getPaymentsMadeForKam = async (purchaseBillId, type) => {
  const response = await api.get(`/kam/paymentsmade/${purchaseBillId}/${type}`);

  return response;
};

export const getPaymentsReceived = async (entityId, type) => {
  const response = await api.get(
    `/account/paymentsreceived/${entityId}/${type}`,
  );

  return response;
};
